<div class="transfer-component">
  <div class="dark-blue">
    <nestas-toolbar [steps]="[]"></nestas-toolbar>
  </div>

  <div class="wrap">

    <mat-card *ngIf="error" align="center" class="mat-card-margin">
      <div class="mat-card-wrapper">
        <div mat-card-image>
          <i class="material-icons red">error</i>
        </div>
        <mat-card-title>{{translate.instant('TRANSFER.NOT_FOUND_OR_TRANSFERRED')}}</mat-card-title>
      </div>
    </mat-card>

    <div *ngIf="!error && pid && profile">
      <div>
        <div class="alert-info alert-info-margin">
          <i class="material-icons ic-info">info</i>
          <span>
            &nbsp;{{translate.instant('TRANSFER.INTRO_MESSAGE')}} {{pid.PIDOwner.name}}
            (<a class="cursor contact-info-data link" href="mailto:{{pid.PIDOwner.email}}">{{pid.PIDOwner.email}}</a>)
          </span>
        </div>
        <div class="display-flex">
          <nestas-pid-card [pid]="pid" [editable]="false"></nestas-pid-card>
          <div class="wrapper-full-width">
            <mat-card>
              <div>
                <mat-card-title>{{translate.instant('DATA.FILES')}}</mat-card-title>
                <div class="wrapper-files">
                  <table class="default-table">
                    <tr>
                      <th>{{translate.instant('DATA.NAME')}}</th>
                      <th>{{translate.instant('DATA.TYPE')}}</th>
                      <th>{{translate.instant('DATA.JOB')}}</th>
                      <th>{{translate.instant('DATA.ROOM')}}</th>
                    </tr>
                    <tr *ngFor="let f of files" class="default-table-line">
                      <td>{{f.name}}</td>
                      <td>{{f.type}}</td>
                      <td>{{f.job}}</td>
                      <td>{{f.room}}</td>
                    </tr>
                  </table>
                </div>
              </div>
            </mat-card>
            <br/>
            <mat-card>
            
              <mat-card-title>{{translate.instant('AUTH.PERSONNAL_INFORMATION')}}</mat-card-title>
              <div class="personnal-information">
                <mat-card-subtitle class="alert-warning">
                  <i class="material-icons ic-warning">warning</i>{{translate.instant('TRANSFER.INTRO_SUBMESSAGE')}}
                </mat-card-subtitle>
                <br/>
                <mat-form-field>
                  <input matInput class="full-width" type="password" [(ngModel)]="newPassword"  name="password"
                         [placeholder]="translate.instant('DATA.NEW_PASSWORD')">
                  <mat-hint *ngIf="!newPassword" align="end" color="warn" class="red">
                    {{translate.instant('MESSAGE.IS_REQUIRED')}}
                  </mat-hint>
                </mat-form-field>

                <mat-form-field>
                  <input matInput class="full-width" type="password" [(ngModel)]="confirmPassword"  name="confirmPassword"
                         [placeholder]="translate.instant('DATA.CONFIRM_PASSWORD')">
                  <mat-hint *ngIf="!confirmPassword" align="end" color="warn" class="red">
                    {{translate.instant('MESSAGE.IS_REQUIRED')}}
                  </mat-hint>
                </mat-form-field>

                <div class="alert-warning text-left" *ngIf="confirmPassword && (newPassword != confirmPassword)">
                  <i class="material-icons ic-warning">warning</i>{{translate.instant('MESSAGE.NOT_MATCH', {data:
                  translate.instant('DATA.PASSWORD')})}}
                </div>
                <div *ngIf="confirmPassword && (newPassword != confirmPassword)" class="alert-separator"></div>
                <div class="alert-info text-left" *ngIf="!passwordSecured()">
                  <i class="material-icons ic-info">info</i>{{translate.instant('MESSAGE.ERROR.UNSECURE_PASSWORD')}}
                </div>
                <br/><br/>
                <mat-form-field>
                  <input matInput class="full-width" [(ngModel)]="profile.firstname" type="text" name="name"
                         [placeholder]="translate.instant('DATA.FIRSTNAME')">
                  <mat-hint *ngIf="!profile.firstname" align="end" color="warn" class="red">
                    {{translate.instant('MESSAGE.IS_REQUIRED')}}
                  </mat-hint>
                </mat-form-field>
                <mat-form-field>
                  <input matInput class="full-width" [(ngModel)]="profile.lastname" type="text" name="name"
                         [placeholder]="translate.instant('DATA.LASTNAME')">
                  <mat-hint *ngIf="!profile.lastname" align="end" color="warn" class="red">
                    {{translate.instant('MESSAGE.IS_REQUIRED')}}
                  </mat-hint>
                </mat-form-field>
                <input matInput class="full-width" [(ngModel)]="profile.phone" type="phone" name="phone"
                       [placeholder]="translate.instant('DATA.PHONE')"><br/><br/><br/>

                <label class="default-label ">{{translate.instant('DATA.ADDRESS')}}</label><br/>
                <mat-form-field>
                  <input matInput class="full-width" [(ngModel)]="profile.address.address" type="text"
                         [placeholder]="translate.instant('DATA.STREET_AND_NUMBER')">
                  <mat-hint *ngIf="!profile.address.address" align="end" color="warn" class="red">
                    {{translate.instant('MESSAGE.IS_REQUIRED')}}
                  </mat-hint>
                </mat-form-field>
                <mat-form-field>
                  <input matInput class="full-width" [(ngModel)]="profile.address.zip" type="number"
                         [placeholder]="translate.instant('DATA.ZIP')">
                  <mat-hint *ngIf="!profile.address.zip" align="end" color="warn" class="red">
                    {{translate.instant('MESSAGE.IS_REQUIRED')}}
                  </mat-hint>
                </mat-form-field>
                <br/>

                <mat-form-field>
                  <input matInput class="full-width" [(ngModel)]="profile.address.city" type="text"
                         [placeholder]="translate.instant('DATA.CITY')">
                  <mat-hint *ngIf="!profile.address.city" align="end" color="warn" class="red">
                    {{translate.instant('MESSAGE.IS_REQUIRED')}}
                  </mat-hint>
                </mat-form-field>
                <mat-form-field>
                  <input matInput class="full-width" [(ngModel)]="profile.address.country" type="text"
                         [placeholder]="translate.instant('DATA.COUNTRY')">
                  <mat-hint *ngIf="!profile.address.country" align="end" color="warn" class="red">
                    {{translate.instant('MESSAGE.IS_REQUIRED')}}
                  </mat-hint>
                </mat-form-field>
                <br/><br/><br/>
              </div>
             
            </mat-card>


            <mat-card>
             
              <mat-card-title>{{translate.instant('TRANSFER.TRANSFER_AGREEMENT')}}</mat-card-title>
              <div class="personnal-information">
                <mat-card-subtitle class="alert-warning">
                  <i class="material-icons ic-warning">warning</i><span [innerHTML]="translate.instant('TRANSFER.AGREEMENT_SUBMESSAGE')"></span><br />
                  <a target="_blank" class="link" href="{{translate.instant('TRANSFER.URL1')}}">{{translate.instant('TRANSFER.URL1_NAME')}}</a><br />
                  <a target="_blank" class="link" href="{{translate.instant('TRANSFER.URL2')}}">{{translate.instant('TRANSFER.URL2_NAME')}}</a>

                </mat-card-subtitle>
                <br/>
                  <mat-checkbox [(ngModel)]="agreed">{{translate.instant('TRANSFER.I_AGREE')}}</mat-checkbox>
                
                <br/><br/><br/>
              </div>
              <button class="confirm-btn" mat-raised-button color="primary" [disabled]="!informationComplete() || transferPending"
                      (click)="UpdateAndAcceptTransfer()">
                      <span *ngIf="!transferPending">{{translate.instant('TRANSFER.ACCEPT_TRANSFER')}}</span>
                      <span *ngIf="transferPending">{{translate.instant('TRANSFER.PLEASE_WAIT')}}</span>
              </button>
            </mat-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
